<template>
  <div v-if="alert.showAlert" :class="['alert', 'fade', 'alert-dismissible', 'fixed-top', alertClass]" tabindex="-1" role="alert" id="stemAlert" aria-labelledby="stemAlertLabel" :aria-hidden="!alert.showAlert">
    <strong>{{ alert.title }}: </strong> {{ alert.message }}
    <button type="button" class="btn-close" aria-label="Close" @click="hide"></button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'StemAlertNotification',
  computed: {
    ...mapGetters(['alert']),
    alertClass() {
      return {
        'alert-danger': this.alert.type === 'error',      // red
        'alert-success': this.alert.type === 'success',   // green
        'alert-warning': this.alert.type === 'warning',   // yellow 
        'alert-info': this.alert.type === 'notification', // blue
        'show': this.alert.showAlert
      };
    }
  },
  watch: {
    'alert.showAlert'(newVal) {
      const alertElement = document.getElementById('stemAlert');
      if (alertElement) {
        alertElement.setAttribute('aria-hidden', !newVal);
      }
    }
  },
  methods: {
    hide() {
      this.$store.commit('hideAlert');
    }
  }
};
</script>

<style scoped>
.fixed-top {
  position: fixed;
  margin-top: 1%;
  margin-left: 15%;
  margin-right: 15%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1050; /* Ensure it appears above other content */
}
</style>
